import { Component, Input } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-resource-browse-card",
    templateUrl: "./resource-browse-card.component.html",
    styleUrls: ["./resource-browse-card.component.scss"],
})
export class ResourceBrowseCardComponent extends CardComponent {
    @Input() public type: string = "standard" //  standard/medium/large
    @Input() public listenToResize: boolean = false
    @Input() public gtmDataCardNumber: number

    constructor(public userService: UserService) {
        super(userService)
    }

    public isLargeCard() {
        return this.type === "large"
    }

    public isMediumCard() {
        return this.type === "medium"
    }

    public isStandardCard() {
        return this.type === "standard"
    }

    public getCardType() {
        return {
            large: this.isLargeCard(),
            medium: this.isMediumCard(),
        }
    }

    /**
     * get the image size for standard, medium and large cards [width, height]
     */
    public getPosterImageSize() {
        if (this.isLargeCard()) {
            return [413, 233]
        }

        if (this.isMediumCard()) {
            return [282, 159]
        }

        return [260, 165]
    }

    public getPosterImageWidth() {
        return this.getPosterImageSize()[0]
    }

    public getPosterImageHeight() {
        return this.getPosterImageSize()[1]
    }

    public getMediaType() {
        if (this.learningObject.mediaType && this.learningObject.mediaType.length) {
            return this.learningObject.mediaType[0]
        }
        return ""
    }

    public truncateSize() {
        let titleLength = this.learningObject.title.length
        let descLength

        if (this.isStandardCard()) {
            if (titleLength >= 77) {
                titleLength = 77
                descLength = 150
            } else {
                descLength = 130
            }
            return descLength - titleLength
        }

        if (this.isLargeCard()) {
            descLength = 150
            if (titleLength >= 167) {
                return 0
            }
            return descLength - titleLength
        }
        return 0
    }

    public titleHeight() {
        if (this.isLargeCard()) {
            return this.learningObject.title.length >= 115 ? 64 : 0
        }
        return this.learningObject.title.length > 60 ? 64 : 0
    }
}
